(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["el-var-gifts"] && !Shopify.designMode) return;
  try {
    
import('@theme/component').then(({ Component }) => {
class ElvarGiftForm extends Component {
  updateTotal() {
    const form = this.querySelector('form');
    const total = [...form.querySelectorAll('select')].reduce((sum, select) => sum + Number(select.selectedOptions[0]?.dataset.price || 0), 0);
    const extra = form.querySelectorAll('select')[1];
    const discount = extra && form.dataset.offerFrames.split(',').includes(extra.value) ? Number(form.dataset.discount || 0) : 0;
    const formatter = new Intl.NumberFormat(form.dataset.locale === 'es' ? 'es-CL' : form.dataset.locale, { style: 'currency', currency: form.dataset.currency, currencyDisplay: 'narrowSymbol', maximumFractionDigits: 0 });
    this.refs.total.textContent = formatter.format((total - discount) / 100);
    if (this.refs.original) this.refs.original.textContent = formatter.format(total / 100);
  }
  async addGift(event) {
    event.preventDefault();
    if (this.refs.button.disabled) return;
    const form = event.target;
    if (!form.reportValidity()) return;
    this.refs.button.disabled = true;
    this.refs.status.textContent = '';
    try {
      const items = [...form.querySelectorAll('select')].map(select => ({ id: Number(select.value), quantity: 1 }));
      const response = await fetch(`${form.action}.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || form.dataset.error);
      window.location.assign(form.dataset.cartUrl);
    } catch (error) {
      this.refs.status.textContent = error.message || form.dataset.error;
      this.refs.button.disabled = false;
    }
  }
}
if (!customElements.get('elvar-gift-form')) customElements.define('elvar-gift-form', ElvarGiftForm);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }
(() => {
const main = document.getElementById('MainContent');
if (main) {
  const grids = new Map();
  let frame;
  const update = () => {
    frame = undefined;
    const changes = [];
    for (const [grid, observers] of grids) {
      if (!grid.isConnected) {
        observers.forEach((observer) => observer.disconnect());
        grids.delete(grid);
        continue;
      }
      for (const gallery of grid.querySelectorAll('.card-gallery')) {
        const image = gallery.querySelector('slideshow-slide[aria-hidden="false"] .product-media__image') || gallery.querySelector('.product-media__image');
        if (!image) continue;
        const width = Math.ceil(image.getBoundingClientRect().width);
        if (!width) continue;
        const sizes = `${image.loading === 'lazy' ? 'auto, ' : ''}${width}px`;
        if (image.getAttribute('sizes') !== sizes) changes.push([image, sizes]);
      }
    }
    for (const [image, sizes] of changes) image.setAttribute('sizes', sizes);
  };
  const schedule = () => {
    if (!frame) frame = requestAnimationFrame(update);
  };
  const mount = () => {
    for (const grid of main.querySelectorAll('.product-grid')) {
      if (grids.has(grid)) continue;
      let lastWidth;
      const resize = new ResizeObserver(([entry]) => {
        if (entry.contentRect.width === lastWidth) return;
        lastWidth = entry.contentRect.width;
        schedule();
      });
      resize.observe(grid);
      const mutations = new MutationObserver(schedule);
      mutations.observe(grid, { attributes: true, attributeFilter: ['product-grid-view'] });
      grid.addEventListener('click', schedule, { passive: true });
      grids.set(grid, [resize, mutations]);
    }
    schedule();
  };
  new MutationObserver((records) => {
    if (records.some((record) => record.target.matches?.('.product-grid'))) schedule();
    if (records.some((record) => [...record.addedNodes].some((node) => node.nodeType === 1 && (node.matches('.product-grid') || node.querySelector('.product-grid'))))) mount();
  }).observe(main, { childList: true, subtree: true });
  mount();
}
})();

  } catch(e) { console.error(e); }
})();
})();
